import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ApiHelper } from '../../utils/apiHelper';

export const fetchMailTemplates = createAsyncThunk(
    'mailTemplates/fetchMailTemplates',
    async () => {
        const response = await ApiHelper.get('/admin/mail-templates');
        return response.data.templates;
    }
);

export const updateMailTemplate = createAsyncThunk(
    'mailTemplates/updateMailTemplate',
    async ({ mailTemplateId, body }) => {
        const response = await ApiHelper.put('/admin/mail-template', {
            mailTemplateId,
            body
        });
        return response.data;
    }
);

const initialState = {
    templates: [],
    selectedTemplate: null,
    loading: false,
    error: null
};

const mailTemplatesSlice = createSlice({
    name: 'mailTemplates',
    initialState,
    reducers: {
        setSelectedTemplate: (state, action) => {
            state.selectedTemplate = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchMailTemplates.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchMailTemplates.fulfilled, (state, action) => {
                state.loading = false;
                state.templates = action.payload;
            })
            .addCase(fetchMailTemplates.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(updateMailTemplate.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateMailTemplate.fulfilled, (state, action) => {
                state.loading = false;
                const updatedTemplate = action.payload;
                state.templates = state.templates.map(template =>
                    template.mailTemplateId === updatedTemplate.mailTemplateId
                        ? updatedTemplate
                        : template
                );
                if (state.selectedTemplate?.mailTemplateId === updatedTemplate.mailTemplateId) {
                    state.selectedTemplate = updatedTemplate;
                }
            })
            .addCase(updateMailTemplate.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    }
});

export const { setSelectedTemplate } = mailTemplatesSlice.actions;
export default mailTemplatesSlice.reducer; 